import { createAction } from '@reduxjs/toolkit';
import { normalizeError } from 'core/common/errors';
import { AppThunk } from 'core/common/store/types';
import { AnyOffersAttributes, getOffersConfigType, Offers } from 'core/offers/entities';
import { OfferMapper } from '../../mappers';

export const fetchOffersPending = createAction('offers/FETCH_OFFERS/pending');
export const fetchOffersSucceed = createAction<Array<Offers>>('offers/FETCH_OFFERS/succeed');
export const fetchOffersFailed = createAction('offers/FETCH_OFFERS/failed');

export const fetchOffersByCategory =
  (offersAttributes: Array<AnyOffersAttributes>): AppThunk =>
  async (dispatch, getState, context) => {
    const { offersService, loggingService, analyticsService } = context;

    dispatch(fetchOffersPending());

    if (offersAttributes.length) {
      analyticsService.updateUserProperties({
        offers_config_type: getOffersConfigType(offersAttributes),
      });
    }

    const mapper = new OfferMapper();

    const offerIds = mapper.mapAttributesToUniqueOfferIds(offersAttributes);

    const localizeOffers = offersAttributes.some(
      (attribute) => !!attribute.condition?.localizeOffers,
    );

    try {
      const offers = await offersService.getOffers(offerIds, localizeOffers);

      const mappedOffers = mapper.mapAttributesToOffers(offersAttributes, offers);

      dispatch(fetchOffersSucceed(mappedOffers));
    } catch (e) {
      const err = normalizeError(e);

      loggingService.error(err);
      dispatch(fetchOffersFailed());
    }
  };
